import * as React from 'react';

import { FilterMenu } from '../common/filter/filter-menu.presentation';
import { Pagination } from '../common/pagination/pagination.component';
import { DocumentCard, DocumentItem } from '../common/document/';

export const CategoryDocsList = ({ loading, items, limit, page, total, setPage, view, changeView }) => {
    if (loading) {
        return (<div style={{ padding: 200 }}>
            <div className='ui active inverted dimmer'>
                <div className='ui massive text loader'>Loading</div>
            </div>
        </div>);
    }
    else if (items.length === 0) {
        return (<div className='container'><h2>No articles available</h2></div>);
    }

    const css = 'ui ' + view + (view === 'cards' ? ' six doubling' : '');

    return (<div className='container'>
        <FilterMenu doRefresh={null} view={view} changeView={changeView} />
        <div className={css}>
            {items.map(item => {
                if (view === 'cards') {
                    return <DocumentCard key={item._id} document={item} />;
                }
                else {
                    return <DocumentItem key={item._id} document={item} />;
                }
            })}
        </div>
        <Pagination limit={limit} total={total} currentPage={page} selectPage={setPage} />
    </div>);
};



// WEBPACK FOOTER //
// ./src/components/category-articles/category-articles-list.presentation.tsx